/* tslint:disable */

declare var Object: any;
export interface ERPreportInterface {
  "id"?: number;
}

export class ERPreport implements ERPreportInterface {
  "id": number;
  constructor(data?: ERPreportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPreport`.
   */
  public static getModelName() {
    return "ERPreport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPreport for dynamic purposes.
  **/
  public static factory(data: ERPreportInterface): ERPreport{
    return new ERPreport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPreport',
      plural: 'ERPreports',
      path: 'ERPreports',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPreport.ts